var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.7188C18 11.4375 17.7188 11.1562 17.4375 11.1562H12.8438V6.5625C12.8438 6.28125 12.5625 6 12.2812 6H11.7188C11.3906 6 11.1562 6.28125 11.1562 6.5625V11.1562H6.5625C6.23438 11.1562 6 11.4375 6 11.7188V12.2812C6 12.6094 6.23438 12.8438 6.5625 12.8438H11.1562V17.4375C11.1562 17.7656 11.3906 18 11.7188 18H12.2812C12.5625 18 12.8438 17.7656 12.8438 17.4375V12.8438H17.4375C17.7188 12.8438 18 12.6094 18 12.2812V11.7188ZM23.625 12C23.625 5.57812 18.4219 0.375 12 0.375C5.57812 0.375 0.375 5.57812 0.375 12C0.375 18.4219 5.57812 23.625 12 23.625C18.4219 23.625 23.625 18.4219 23.625 12ZM22.125 12C22.125 17.5781 17.5781 22.125 12 22.125C6.42188 22.125 1.875 17.625 1.875 12C1.875 6.46875 6.375 1.875 12 1.875C17.5312 1.875 22.125 6.42188 22.125 12Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.2bcc940d.svg";
export { ForwardRef as ReactComponent };